<div class="pl-4 pr-1 pt-0 !bg-transparent">
  <div class="flex justify-end">
    <div class="flex flex-wrap sm:flex-nowrap items-center gap-2 sm:gap-4"
    >
      <p-button
        [routerLink]="['/demandas/mapa']"
        styleClass="btn-primary !h-8 text-xs sm:text-sm md:text-base px-2 sm:px-4"
      >
        <app-icon-bold-map size="18px"/>
        <span class="hidden sm:inline">Mapa</span>
      </p-button>
      <p-button
        [routerLink]="['/demandas/lista']"
        styleClass="btn-primary !h-8 text-xs sm:text-sm md:text-base px-2 sm:px-4"
      >
        <app-icon-bold-receipt-2 size="16px"/>
        <span class="hidden sm:inline">Lista</span>
      </p-button>

      <p-button
        [routerLink]="['/demandas/mapa-calor']"
        styleClass="btn-primary !h-8 text-xs sm:text-sm md:text-base px-2 sm:px-4"
      >
        <app-icon-bold-heat size="18px"/>
        <span class="hidden sm:inline">Mapa de Calor</span>
      </p-button>

      <div class="hidden sm:block w-px h-6 bg-gray-400"></div>

      <p-button
        [routerLink]="['/demandas/adicionar']"
        styleClass="btn-primary !h-8 text-xs sm:text-sm md:text-base px-2 sm:px-4"
      >
        <app-icon-bold-add-square size="18px"/>
        <span class="hidden sm:inline">Adicionar Nova</span>
      </p-button>
    </div>
  </div>
</div>
